var _path, _path2, _path3, _path4, _path5, _path6, _circle, _ellipse, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "under_construction",
    xmlns: "http://www.w3.org/2000/svg",
    width: 372.9,
    height: 154.21,
    viewBox: "0 0 372.9 154.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M105.422,608.609a6.109,6.109,0,0,1,12.218,0",
    transform: "translate(-94.988 -467.864)",
    fill: "#ededed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M122.289,613.241a.165.165,0,0,1-.165-.165v-3.22a.165.165,0,0,1,.33,0v3.22A.165.165,0,0,1,122.289,613.241Z",
    transform: "translate(-105.745 -472.495)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M118.7,612.881a.164.164,0,0,1-.107-.04l-1.981-1.7a.165.165,0,0,1,.215-.251l1.981,1.7a.165.165,0,0,1-.108.29Z",
    transform: "translate(-102.159 -473.242)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M158.31,608.609a6.109,6.109,0,0,1,12.218,0",
    transform: "translate(-129.053 -467.864)",
    fill: "#ededed"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M175.177,613.241a.165.165,0,0,1-.165-.165v-3.22a.165.165,0,0,1,.33,0v3.22a.165.165,0,0,1-.165.165Z",
    transform: "translate(-139.811 -472.495)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M171.591,612.881a.164.164,0,0,1-.107-.04l-1.981-1.7a.165.165,0,1,1,.215-.251l1.981,1.7a.165.165,0,0,1-.108.29Z",
    transform: "translate(-136.225 -473.242)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1104",
    "data-name": "Ellipse 1104",
    cx: 11.744,
    cy: 11.744,
    r: 11.744,
    transform: "translate(267.557 0.466)",
    fill: "#ededed"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1105",
    "data-name": "Ellipse 1105",
    cx: 10.677,
    cy: 2.491,
    rx: 10.677,
    ry: 2.491,
    transform: "translate(28.042 148.872)",
    fill: "#ededed"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M167.669,273.29c2.8-8.744,9.637-15.525,17.746-19.558,9.621-4.785,20.676-5.327,31.122-3.465,11.277,2.01,21.816,6.645,32.018,11.7,10.006,4.961,19.852,10.2,30.258,14.3a195.873,195.873,0,0,0,65.109,13.487c20.083.67,41.556-1.531,58.752-12.818,15.756-10.343,25.782-27.406,31-45.192q1-3.416,1.783-6.89c.152-.669-.877-.955-1.03-.284-4.212,18.573-13.194,36.93-28.542,48.769-16.6,12.805-38.384,15.765-58.771,15.426a194.927,194.927,0,0,1-65.958-12.728c-10.674-4.064-20.747-9.34-30.948-14.435-9.977-4.982-20.234-9.646-31.205-11.944-10.018-2.1-20.744-2.226-30.4,1.508-7.953,3.075-15.205,8.555-19.449,16.052a30.783,30.783,0,0,0-2.517,5.785c-.21.656.82.937,1.03.284Z",
    transform: "translate(-134.4 -224.191)",
    fill: "#ededed"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M545.069,586.717a.356.356,0,0,0,0-.712h-3.381v-1.424h3.381a.356.356,0,1,0,0-.712H516.242a.356.356,0,1,0,0,.712h3.381v1.424h-3.381a.356.356,0,0,0,0,.712h3.381v1.424h-3.381a.356.356,0,1,0,0,.712h3.381v1.424H516.6a.712.712,0,0,0,0,1.424h2.88a.532.532,0,0,0-.033.178v4.982a.534.534,0,1,0,1.068,0v-4.982a.532.532,0,0,0-.033-.178h20.351a.53.53,0,0,0-.033.178v4.982a.534.534,0,1,0,1.068,0v-4.982a.53.53,0,0,0-.033-.178h2.88a.712.712,0,0,0,0-1.424h-3.025v-1.424h3.381a.356.356,0,1,0,0-.712h-3.381v-1.424Zm-24.734-2.135h20.642v1.424H520.334Zm20.642,5.694H520.334v-1.424h20.642Zm0-2.135H520.334v-1.424h20.642Z",
    transform: "translate(-206.048 -455.864)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M251.675,511.529c0-6.285-5.1-21.2-11.388-21.2s-11.388,14.915-11.388,21.2a11.389,11.389,0,0,0,22.777,0Z",
    transform: "translate(-174.519 -395.613)",
    fill: "#dedede"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M243.675,511.529c0-6.285-5.1-21.2-11.388-21.2s-11.388,14.915-11.388,21.2a11.389,11.389,0,0,0,22.777,0Z",
    transform: "translate(-169.366 -395.613)",
    fill: "#ededed"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M253.254,562.744a.356.356,0,0,1-.356-.356V530.664a.356.356,0,1,1,.712,0v31.724A.356.356,0,0,1,253.254,562.744Z",
    transform: "translate(-189.978 -421.364)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M253.254,536.21A.356.356,0,0,1,253,535.6l4.654-4.654a.356.356,0,0,1,.5.5l-4.654,4.654a.355.355,0,0,1-.252.1Z",
    transform: "translate(-189.978 -421.709)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M621.254,562.744a.356.356,0,0,1-.356-.356V530.664a.356.356,0,1,1,.712,0v31.724A.356.356,0,0,1,621.254,562.744Z",
    transform: "translate(-273.687 -421.364)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M687.675,511.529c0-6.285-5.1-21.2-11.388-21.2s-11.388,14.915-11.388,21.2a11.389,11.389,0,0,0,22.777,0Z",
    transform: "translate(-495.351 -395.613)",
    fill: "#dedede"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M679.675,511.529c0-6.285-5.1-21.2-11.388-21.2s-11.388,14.915-11.388,21.2a11.389,11.389,0,0,0,22.777,0Z",
    transform: "translate(-490.198 -395.613)",
    fill: "#ededed"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M689.254,562.744a.356.356,0,0,1-.356-.356V530.664a.356.356,0,1,1,.712,0v31.724A.356.356,0,0,1,689.254,562.744Z",
    transform: "translate(-510.81 -421.364)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M689.254,536.21A.356.356,0,0,1,689,535.6l4.654-4.654a.356.356,0,0,1,.5.5l-4.654,4.654A.354.354,0,0,1,689.254,536.21Z",
    transform: "translate(-510.81 -421.709)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M346.693,246.371H341a1.6,1.6,0,0,1-1.6-1.6V231.6A1.6,1.6,0,0,1,341,230h5.694a1.6,1.6,0,0,1,1.6,1.6v13.168A1.6,1.6,0,0,1,346.693,246.371Z",
    transform: "translate(-245.693 -227.933)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M364.606,396.85H335.423a3.028,3.028,0,0,1-3.025-3.025v-117.8A3.029,3.029,0,0,1,335.423,273h29.183a3.028,3.028,0,0,1,3.025,3.025v117.8A3.028,3.028,0,0,1,364.606,396.85Z",
    transform: "translate(-241.185 -255.629)",
    fill: "#dedede"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M315.606,396.85H286.423a3.028,3.028,0,0,1-3.025-3.025v-117.8A3.029,3.029,0,0,1,286.423,273h29.183a3.028,3.028,0,0,1,3.025,3.025v117.8A3.028,3.028,0,0,1,315.606,396.85Z",
    transform: "translate(-209.623 -255.629)",
    fill: "#ededed"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M331.693,246.371H326a1.6,1.6,0,0,1-1.6-1.6V231.6A1.6,1.6,0,0,1,326,230h5.694a1.6,1.6,0,0,1,1.6,1.6v13.168A1.6,1.6,0,0,1,331.693,246.371Z",
    transform: "translate(-236.032 -227.933)",
    fill: "#f2f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M310.049,326.1h-6.762a.891.891,0,0,1-.89-.89V314.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321a.891.891,0,0,1-.89.89Z",
    transform: "translate(-221.861 -282.038)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M347.049,326.1h-6.762a.891.891,0,0,1-.89-.89V314.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321a.891.891,0,0,1-.89.89Z",
    transform: "translate(-245.693 -282.038)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M310.049,379.1h-6.762a.891.891,0,0,1-.89-.89V367.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,310.049,379.1Z",
    transform: "translate(-221.861 -316.176)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M347.049,379.1h-6.762a.891.891,0,0,1-.89-.89V367.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,347.049,379.1Z",
    transform: "translate(-245.693 -316.176)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M310.049,432.1h-6.762a.891.891,0,0,1-.89-.89V420.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,310.049,432.1Z",
    transform: "translate(-221.861 -350.313)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M347.049,432.1h-6.762a.891.891,0,0,1-.89-.89V420.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,347.049,432.1Z",
    transform: "translate(-245.693 -350.313)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M310.049,485.1h-6.762a.891.891,0,0,1-.89-.89V473.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,310.049,485.1Z",
    transform: "translate(-221.861 -384.451)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M347.049,485.1h-6.762a.891.891,0,0,1-.89-.89V473.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,347.049,485.1Z",
    transform: "translate(-245.693 -384.451)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M310.049,538.1h-6.762a.891.891,0,0,1-.89-.89V526.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,310.049,538.1Z",
    transform: "translate(-221.861 -418.589)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M347.049,538.1h-6.762a.891.891,0,0,1-.89-.89V526.89a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,347.049,538.1Z",
    transform: "translate(-245.693 -418.589)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M759.693,431.677H754a1.6,1.6,0,0,1-1.6-1.6V422.6A1.6,1.6,0,0,1,754,421h5.694a1.6,1.6,0,0,1,1.6,1.6v7.474A1.6,1.6,0,0,1,759.693,431.677Z",
    transform: "translate(-551.711 -350.958)",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M849.606,508.637H820.423a3.029,3.029,0,0,1-3.025-3.025V449.025A3.029,3.029,0,0,1,820.423,446h29.183a3.028,3.028,0,0,1,3.025,3.025v56.587A3.028,3.028,0,0,1,849.606,508.637Z",
    transform: "translate(-593.578 -367.06)",
    fill: "#dedede"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M761.959,508.637H711.423a3.028,3.028,0,0,1-3.025-3.025V449.025A3.028,3.028,0,0,1,711.423,446h50.536a3.028,3.028,0,0,1,3.025,3.025v56.587A3.028,3.028,0,0,1,761.959,508.637Z",
    transform: "translate(-523.37 -367.06)",
    fill: "#ededed"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M744.693,431.677H739a1.6,1.6,0,0,1-1.6-1.6V422.6A1.6,1.6,0,0,1,739,421h5.694a1.6,1.6,0,0,1,1.6,1.6v7.474A1.6,1.6,0,0,1,744.693,431.677Z",
    transform: "translate(-542.049 -350.958)",
    fill: "#f2f2f2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M765.049,502.6h-6.762a.891.891,0,0,1-.89-.89V491.39a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,765.049,502.6Z",
    transform: "translate(-554.931 -395.723)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M802.049,502.6h-6.762a.891.891,0,0,1-.89-.89V491.39a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,802.049,502.6Z",
    transform: "translate(-578.763 -395.723)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M765.049,555.6h-6.762a.891.891,0,0,1-.89-.89V544.39a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,765.049,555.6Z",
    transform: "translate(-554.931 -429.861)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M802.049,555.6h-6.762a.891.891,0,0,1-.89-.89V544.39a.891.891,0,0,1,.89-.89h6.762a.891.891,0,0,1,.89.89v10.321A.891.891,0,0,1,802.049,555.6Z",
    transform: "translate(-578.763 -429.861)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M448.647,621.212H76.458a.356.356,0,0,1,0-.712H448.647a.356.356,0,0,1,0,.712Z",
    transform: "translate(-76.102 -479.458)",
    fill: "#dedede"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M378.351,656.212h-33.1a.356.356,0,1,1,0-.712h33.1a.356.356,0,0,1,0,.712Z",
    transform: "translate(-249.236 -502.001)",
    fill: "#dedede"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M609.351,656.212h-33.1a.356.356,0,1,1,0-.712h33.1a.356.356,0,1,1,0,.712Z",
    transform: "translate(-398.025 -502.001)",
    fill: "#dedede"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M840.351,656.212h-33.1a.356.356,0,1,1,0-.712h33.1a.356.356,0,1,1,0,.712Z",
    transform: "translate(-546.815 -502.001)",
    fill: "#dedede"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M450.675,511.529c0-6.285-5.1-21.2-11.388-21.2s-11.388,14.915-11.388,21.2a11.389,11.389,0,0,0,22.777,0Z",
    transform: "translate(-302.697 -395.613)",
    fill: "#dedede"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M442.675,511.529c0-6.285-5.1-21.2-11.388-21.2s-11.388,14.915-11.388,21.2a11.389,11.389,0,0,0,22.777,0Z",
    transform: "translate(-297.544 -395.613)",
    fill: "#ededed"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M452.254,562.744a.356.356,0,0,1-.356-.356V530.664a.356.356,0,1,1,.712,0v31.724A.356.356,0,0,1,452.254,562.744Z",
    transform: "translate(-318.156 -421.364)",
    fill: "#ccc"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M452.254,536.21A.356.356,0,0,1,452,535.6l4.654-4.654a.356.356,0,0,1,.5.5l-4.654,4.654a.355.355,0,0,1-.252.1Z",
    transform: "translate(-318.156 -421.709)",
    fill: "#ccc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M961.675,511.529c0-6.285-5.1-21.2-11.388-21.2s-11.388,14.915-11.388,21.2a11.388,11.388,0,1,0,22.777,0Z",
    transform: "translate(-671.837 -395.613)",
    fill: "#dedede"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M953.675,511.529c0-6.285-5.1-21.2-11.389-21.2s-11.388,14.915-11.388,21.2a11.388,11.388,0,1,0,22.777,0Z",
    transform: "translate(-666.684 -395.613)",
    fill: "#ededed"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M963.254,562.744a.356.356,0,0,1-.356-.356V530.664a.356.356,0,1,1,.712,0v31.724A.356.356,0,0,1,963.254,562.744Z",
    transform: "translate(-687.296 -421.364)",
    fill: "#ccc"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M963.254,536.21A.356.356,0,0,1,963,535.6l4.654-4.654a.356.356,0,0,1,.5.5l-4.654,4.654A.355.355,0,0,1,963.254,536.21Z",
    transform: "translate(-687.296 -421.709)",
    fill: "#ccc"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M617.117,543.609h-7.83a.891.891,0,0,1-.89-.89v-7.83a.89.89,0,0,1,.89-.89h7.83a.891.891,0,0,1,.89.89v7.83A.891.891,0,0,1,617.117,543.609Z",
    transform: "translate(-265.636 -423.742)",
    fill: "#ccc"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M989.422,608.609a6.109,6.109,0,1,1,12.218,0",
    transform: "translate(-712.381 -467.864)",
    fill: "#ededed"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1006.289,613.241a.165.165,0,0,1-.165-.165v-3.22a.165.165,0,1,1,.33,0v3.22A.165.165,0,0,1,1006.289,613.241Z",
    transform: "translate(-723.138 -472.495)",
    fill: "#ccc"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1002.7,612.881a.164.164,0,0,1-.107-.04l-1.981-1.7a.165.165,0,0,1,.215-.251l1.981,1.7a.165.165,0,0,1-.108.29Z",
    transform: "translate(-719.552 -473.242)",
    fill: "#ccc"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1042.31,608.609a6.109,6.109,0,0,1,12.218,0",
    transform: "translate(-746.446 -467.864)",
    fill: "#ededed"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1059.177,613.241a.165.165,0,0,1-.165-.165v-3.22a.165.165,0,1,1,.33,0v3.22a.165.165,0,0,1-.165.165Z",
    transform: "translate(-757.204 -472.495)",
    fill: "#ccc"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1055.591,612.881a.164.164,0,0,1-.107-.04l-1.981-1.7a.165.165,0,1,1,.215-.251l1.981,1.7a.165.165,0,0,1-.108.29Z",
    transform: "translate(-753.618 -473.242)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/under-construction.1bb28b1e103dbe157fab10714d976f6a.svg";
export { ForwardRef as ReactComponent };